import { useEffect, useState } from 'react';

/**
 * Returns `true` only after `loading` has been continuously `true` for at least `delay` ms.
 * Resets to `false` immediately when `loading` becomes `false`.
 *
 * Use this to gate skeleton/loading UIs so they never flash for fast responses.
 *
 * @example
 * const showSkeleton = useDelayedLoading(loading && items.length === 0);
 * if (showSkeleton) return <Skeleton />;
 */
export function useDelayedLoading(loading: boolean, delay = 150): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShow(false);
      return;
    }
    const id = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(id);
  }, [loading, delay]);

  return show;
}
